import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useSharedMissingPerson(personId) {
  const queryKey = ['sharedMissingPersons', personId];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) =>
      platformApi.get(`shared-missing-persons/${personId}`, { signal }).json(),
    enabled: !!personId,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
